import CONSTANTS from "@/common/constants";
import { iInterface } from "@/services";

const state = {
  interfaceName: "",
  interfaceProjectName: "",
  interfaceData: [],
  selectedClassKey: "",

  isCopy: false,
};

const mutations = {
  setInterfaceData: (state, data) => {
    state.interfaceData = data;
  },
  // 인터페이스 이름 설정
  setInterfaceName: (state, data) => {
    state.interfaceName = data;
  },
  // 인터페이스 프로젝트 이름 설정
  setInterfaceProjectName: (state, data) => {
    state.interfaceProjectName = data;
  },
  // 선택한 클래스 index 설정
  setselectedClassKey: (state, data) => {
    state.selectedClassKey = data;
  },
  // 복사 설정
  setIsCopy: (state, data) => {
    state.isCopy = data;
  },
  // 박스, 폴리곤 옵션 상세설정
  setDetailOptions: (state, data) => {
    const idx = state.interfaceData.findIndex(
      (item) => item.key === state.selectedClassKey
    );
    state.interfaceData[idx].options = data;
  },
  // 그룹포인트 상세설정
  setGroupPointDetail: (state, data) => {
    const idx = state.interfaceData.findIndex(
      (item) => item.key === state.selectedClassKey
    );
    state.interfaceData[idx].childrens = data;
  },
  // 하위작업 이름 변경
  setSubtaskName: (state, { idx, name, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    attributes[idx - 1].name = name;
    attributes[idx - 1].validMsg = "";
  },
  // 하위작업 타입 변경
  setSubtaskType: (state, { idx, type, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    let selectedAttr = attributes[idx - 1];

    let attrType = "";
    switch (type) {
      case CONSTANTS.ATTR_TYPE_LIST[0]: // 단일 선택
        attrType = "RADIO";
        selectedAttr.option.minimum = "";
        selectedAttr.option.maximum = "";
        selectedAttr.option.type = "NONE";
        Array.from(selectedAttr.values).forEach((obj) => {
          obj.selected = false;
        });
        break;
      case CONSTANTS.ATTR_TYPE_LIST[1]: // 다중 선택
        attrType = "CHECKBOX";
        selectedAttr.option.minimum = "";
        selectedAttr.option.maximum = "";
        selectedAttr.option.type = "NONE";
        Array.from(selectedAttr.values).forEach((obj) => {
          obj.selected = false;
        });
        break;
      case CONSTANTS.ATTR_TYPE_LIST[2]: // 문자 입력
        attrType = "INPUT";
        selectedAttr.option.type = "NUMBER";
        selectedAttr.values = [];
        break;
    }
    selectedAttr.type = attrType;
  },
  // 하위작업 옵션 아이템 선택 상태 변경
  setSubtaskOptionItemState: (state, { idx, itemIdx, multiple, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    const selectedValues = attributes[idx - 1].values;
    if (!multiple) {
      selectedValues.forEach((obj, i) => {
        if (itemIdx !== i) obj.selected = false;
      });
    }
    selectedValues[itemIdx].selected = !selectedValues[itemIdx].selected;
  },
  // 하위작업 토글 상태 변경
  setSubtaskToggleState: (state, { idx, required, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    attributes[idx - 1].option.required = required;
  },
  // 하위작업 옵션 타입 변경
  setSubtaskOptionType: (state, { idx, type, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    let optionType = "NONE";
    switch (type) {
      case CONSTANTS.TEXT_TYPE_LIST[0]: // 숫자
        optionType = "NUMBER";
        break;
      case CONSTANTS.TEXT_TYPE_LIST[1]: // 글자
        optionType = "STRING";
        break;
      case CONSTANTS.TEXT_TYPE_LIST[2]: // 단어
        optionType = "WORD";
        break;
    }
    attributes[idx - 1].option.type = optionType;
  },
  // 하위작업 옵션 문자 입력 최솟값 변경
  setSubtaskOptionTextMinimum: (state, { idx, value, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    attributes[idx - 1].option.minimum = value;
    attributes[idx - 1].validMsg = "";
  },
  // 하위작업 옵션 문자 입력 최댓값 변경
  setSubtaskOptionTextMaximum: (state, { idx, value, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    attributes[idx - 1].option.maximum = value;
    attributes[idx - 1].validMsg = "";
  },
  // 하위작업 옵션 컬러 팔레트 설정
  setSubtaskOptionColorPalette: (state, { idx, value, isLine }) => {
    const selectedObj = findSelectedObj(state);
    if (!selectedObj) return;

    const attributes = findSelectedObjAttributes(state, isLine);
    const selectedAttr = attributes[idx - 1];

    selectedAttr.colorPalette = value;
    selectedAttr.values.forEach(
      (item) => (item.color = value ? selectedObj.color : "")
    );
  },
  // 하위작업 옵셥 컬러 설정
  setSubtaskOptionColor: (state, { idx, optionIdx, hex, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    attributes[idx - 1].values[optionIdx].color = hex;
  },
  // 클래스 색상 변경
  setClassColor: (state, data) => {
    const selectedObj = findSelectedObj(state);
    selectedObj.color = data;
  },

  // 선 설정 토글
  setLineAttribute: (state, dataObj) => {
    const selectedObj = findSelectedObj(state);
    selectedObj.lineAttribute.option = {
      ...selectedObj.lineAttribute.option,
      ...dataObj,
    };
  },

  // 클래스 추가
  addClass: (state, data) => {
    state.selectedClassKey = data.key;
    state.interfaceData.push(data);
  },
  // 클래스 복제
  copyClass: (state, { idx, newData }) => {
    state.isCopy = true;
    state.interfaceData.splice(idx + 1, 0, newData);
  },
  // 하위작업 추가 (data에 값이 있을경우 해당 값 하위작업에 추가)
  addSubtask: (state, { data, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    attributes.push(data);
  },
  // 하위작업 옵션 아이템 추가
  addSubtaskOptionInputItem: (state, { idx, value, isLine }) => {
    const selectedObj = findSelectedObj(state);
    if (!selectedObj) return;

    const attributes = findSelectedObjAttributes(state, isLine);
    const selectedAttr = attributes[idx - 1];

    // 중복 옵션 체크
    let duplicate = selectedAttr.values.find((v) => {
      if (v.value === value) return true;
    });
    if (duplicate) return;

    selectedAttr.values.push({
      value: value,
      selected: false,
      color: selectedAttr.colorPalette ? selectedObj.color : "", // 컬러팔레트 활성화인 경우 컬러값 추가
    });
    selectedAttr.validMsg = "";
  },

  // 클래스 삭제
  deleteClass: (state, key) => {
    const idx = state.interfaceData.findIndex((item) => item.key === key);
    state.interfaceData.splice(idx, 1);

    if (state.selectedClassKey === key) {
      state.selectedClassKey =
        state.interfaceData.length === 0 ? "" : state.interfaceData[0].key;
    }
  },
  // 하위작업 삭제
  deleteSubtask: (state, { idx, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    attributes.splice(idx - 1, 1);
  },
  // 하위작업 옵션 아이템 삭제
  deleteSubtaskOptionInputItem: (state, { idx, itemIdx, isLine }) => {
    const attributes = findSelectedObjAttributes(state, isLine);
    if (!attributes) return;

    attributes[idx - 1].values.splice(itemIdx, 1);
  },

  // 인터페이스 초기화
  clearInterface: (state) => {
    state.interfaceName = "";
    state.interfaceProjectName = "";
    state.interfaceData = [];
    state.selectedClassKey = "";
  },
};

/** 현재 선택된 클래스 가져오기 */
function findSelectedObj(state) {
  return state.interfaceData.find(
    (item) => item.key === state.selectedClassKey
  );
}
function findSelectedObjAttributes(state, isLine) {
  const selectedObj = findSelectedObj(state);
  if (isLine) {
    return selectedObj.lineAttribute.attributes;
  } else {
    return selectedObj.attributes;
  }
}

const actions = {
  /** 수정: 인터페이스 정보 설정 */
  async setInterfaceInfo({ commit }, interfaceId) {
    const res = await iInterface.getInterfaceDetail({
      id: interfaceId,
    });

    const itfInfo = res.data.interface;
    const classList = itfInfo.classData.map((item, i) => {
      return { ...item, key: i };
    });
    commit("setInterfaceData", classList);
    commit("setInterfaceName", itfInfo.name);
    commit("setInterfaceProjectName", itfInfo.projectName);
    commit("setselectedClassKey", classList[0].key);
    return itfInfo;
  },

  // 인터페이스 생성
  async createInterface({ state }, projectId) {
    let classData = state.interfaceData;
    classData.forEach((cls) => {
      cls.attributes.forEach((attr) => {
        if (attr.option.minimum == "") delete attr.option.minimum;
        if (attr.option.maximum == "") delete attr.option.maximum;
        delete attr.validMsg;
      });
      if (cls.lineAttribute.attributes) {
        cls.lineAttribute.attributes.forEach((attr) => {
          if (attr.option.minimum == "") delete attr.option.minimum;
          if (attr.option.maximum == "") delete attr.option.maximum;
          delete attr.validMsg;
        });
      }
    });

    const filteringClassData = (data) => {
      return data.map(
        ({
          attributes,
          lineAttribute,
          childrens,
          color,
          name,
          options,
          type,
        }) => ({
          attributes,
          lineAttribute,
          childrens,
          color,
          name,
          options,
          type,
        })
      );
    };

    try {
      const payload = {
        name: state.interfaceName,
        projectId: projectId,
        classData: filteringClassData(classData),
      };
      const res = iInterface.createInterface(payload);
      return res;
    } catch (error) {
      console.log(error);
    }
  },

  // 하위작업 validate
  async checkValid({ state }, isLine) {
    let flag = false;

    const attributes = findSelectedObjAttributes(state, isLine);
    attributes.forEach((attr) => {
      if (
        !attr.name.trim() ||
        (attr.type !== "INPUT" && attr.values.length === 0) ||
        (attr.type === "INPUT" && !attr.option.minimum) ||
        (attr.type === "INPUT" && !attr.option.maximum)
      ) {
        // 이름, 옵션 빈값
        attr.validMsg = "문항과 옵션 모두 설정하세요.";
        flag = true;
      } else if (
        (attr.type === "INPUT" &&
          parseInt(attr.option.maximum) < parseInt(attr.option.minimum)) ||
        ((attr.option.type === "STRING" || attr.option.type === "WORD") &&
          parseInt(attr.option.minimum) <= 0)
      ) {
        // 문자 입력 - 잘못된 최솟값, 최댓값 설정
        attr.validMsg = "값의 범위를 수정하세요.";
        flag = true;
      } else {
        attr.validMsg = "";
      }
    });

    // 하위 작업 이름 중복
    var nameArr = attributes.map((item) => item.name);
    var duplicateIdx = nameArr.findIndex(
      (item, i) => nameArr.indexOf(item) != i
    );
    if (duplicateIdx !== -1) {
      attributes[duplicateIdx].validMsg =
        "이미 존재하는 하위 작업입니다. 문항을 수정하세요.";
      flag = true;
    }

    attributes.push();
    return flag;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
